import {
  STATUS_CHAIN,
  STATUS_SIDEBAR_CHANGES,
  STATUS_SIDEBAR_OVERRIDE,
  STATUS_TO_CHAIN_STATUS,
  cloneSectionPagesMap,
  createEmptySectionPagesMap,
  sortSectionPagesMap,
} from '../config';
import { ApplicationStatus } from 'api/btlApplicationForm/types';
import { CaseSidebarItemId, CaseSidebarSection, SectionPagesMap, StatusSidebarChange } from '../types';

function resolveChainStatus(status: ApplicationStatus): ApplicationStatus {
  if (STATUS_CHAIN.includes(status)) {
    return status;
  }

  return STATUS_TO_CHAIN_STATUS[status] ?? ApplicationStatus.NEW;
}

function appendUniqueItems(items: CaseSidebarItemId[], newItems: CaseSidebarItemId[]): CaseSidebarItemId[] {
  const result = [...items];

  newItems.forEach(item => {
    if (!result.includes(item)) {
      result.push(item);
    }
  });

  return result;
}

function applySidebarChange(pagesBySection: SectionPagesMap, change: StatusSidebarChange): SectionPagesMap {
  const nextPages = cloneSectionPagesMap(pagesBySection);

  if (change.add) {
    (Object.keys(change.add) as CaseSidebarSection[]).forEach(section => {
      const itemsToAdd = change.add?.[section] ?? [];
      nextPages[section] = appendUniqueItems(nextPages[section], itemsToAdd);
    });
  }

  if (change.remove) {
    (Object.keys(nextPages) as CaseSidebarSection[]).forEach(section => {
      nextPages[section] = nextPages[section].filter(item => !change.remove?.includes(item));
    });
  }

  return nextPages;
}

function buildPagesFromChain(status: ApplicationStatus): SectionPagesMap {
  const chainStatus = resolveChainStatus(status);
  const chainIndex = STATUS_CHAIN.indexOf(chainStatus);

  if (chainIndex === -1) {
    return createEmptySectionPagesMap();
  }

  let pagesBySection = createEmptySectionPagesMap();

  for (let index = 0; index <= chainIndex; index++) {
    const stepStatus = STATUS_CHAIN[index];
    const change = STATUS_SIDEBAR_CHANGES[stepStatus];

    if (change) {
      pagesBySection = applySidebarChange(pagesBySection, change);
    }
  }

  return sortSectionPagesMap(pagesBySection);
}

export function getAvailablePagesForStatus(status: ApplicationStatus): SectionPagesMap {
  const override = STATUS_SIDEBAR_OVERRIDE[status];

  if (override) {
    return sortSectionPagesMap(cloneSectionPagesMap(override));
  }

  return buildPagesFromChain(status);
}
